import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import './css/contactResto.css';
import { useSelector } from 'react-redux';
import { SendEmailResto } from '../../Api/RestaurantApi/ContactApi';


const Contact = () => {
  const [sujet, setSujet] = useState([]);
  const [contenu, setContenu] = useState([]);
  const [loading, setLoading] = useState(false);

  let location = useLocation();

  const restaurant = useSelector((state) => state.restaurant);


  const handleAddContact = (e) => {
    if (!localStorage.getItem('tokenSociete')) {
      e.preventDefault();
      setLoading(true);
      const data = { nomRestaurant: restaurant.nomRestaurant, email: restaurant.email, sujet: sujet, contenu: contenu };
      SendEmailResto(data).then(function (response) {
        console.log(response);
        if (response.data.title === "success") {
          toast.success(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
        if (error) {
          toast.error(error.response.data?.message);
        }
      }).finally(function () {
        setLoading(false);
        setSujet('');
        setContenu('');
      });
    } else {
      toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
    }
  }


  return (
    <div>
      <Helmet>
        <title>Contact</title>
        <meta name='description' content='Restaurant contact.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='contactResto'>
        <div className='container'>
          <div className='bloc_contactResto'>
            <div className='contact_titre'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-phone'></i> <h1>Avez vous des questions – contactez-nous</h1>
              </div>
              <div className='contact_renseignement'>
                <p>Vous pouvez le formulaire ci-dessous pour nous envoyer un mail,nous vous recontacterons dans les meilleurs délais.</p>
              </div>
            </div>
            <div className='contactResto_content'>
              <form onSubmit={handleAddContact}>
                <h2>Remplissez le formulaire</h2>
                <input type='text' className='form-control' value={sujet} required onChange={(e) => setSujet(e.target.value)} placeholder='Sujet ...' />
                <textarea className='form-control' value={contenu} required onChange={(e) => setContenu(e.target.value)} placeholder='Contenu ...' cols='30' rows='8'></textarea>
                {loading ? <Button className='btn btn_confirmContact' disabled>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    variant="info"
                    className="spiner"
                  />
                  Chargement...
                </Button> : <button type='submit' className='btn btn_send_contact'>Envoyer la demande</button>}

              </form>
              <p className='version'>Version 1</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact